import { createSelector } from '@ngrx/store';
import { EntertainmentTicketState, getEntertainmentTicketSearchState } from '../reducers';

export const getEntertainmentTicketSearchStates = createSelector(getEntertainmentTicketSearchState, (state) => state);

export const getEntertainmentTicketSearchForm = createSelector(
  getEntertainmentTicketSearchStates,
  (state) => state.entertainmentTicketForm
);

export const getEntertainmentTicketSearchResult = createSelector(
  getEntertainmentTicketSearchStates,
  (state) => state.results
);

export const getTicketEventInformation = createSelector(
  getEntertainmentTicketSearchStates,
  (state) => state.eventResult
);

export const getEntertainmentTicketSearchLoading = createSelector(
  getEntertainmentTicketSearchStates,
  (state) => state.loading
);

export const getEntertainmentTicketSearchLoaded = createSelector(
  getEntertainmentTicketSearchStates,
  (state) => state.loaded
);

export const isPageLoaded = createSelector(
  getEntertainmentTicketSearchStates,
  (state: EntertainmentTicketState) => state.paginationResponse.isPageLoaded
);

export const isPageLoading = createSelector(
  getEntertainmentTicketSearchStates,
  (state: EntertainmentTicketState) => state.paginationResponse.isPageLoading
);
